import { createSlice } from "@reduxjs/toolkit";

export interface IServer {
	id: number,
	domain: string,
	ip: string,
	location: string,
	rtmp: string|null,
	hls: string|null,
	wss: string|null,
	mpd: string|null,
	created_at: string|null,
	updated_at: string|null,
	token: string|null,
}

export interface ServerState {
	servers: IServer[],
	server: IServer|null,
	search: IServer[],

	creating: boolean,
	deleting: boolean,
	updating: boolean,
	gettingList: boolean,
	gettingItem: boolean,
	searching: boolean,

	isError: boolean,
	errorCode: number,
	errorMessage: string|null,
}

export const initialState: ServerState = {
	servers: [],
	server: null,
	search: [],

	creating: false,
	deleting: false,
	updating: false,
	gettingList: false,
	gettingItem: false,
	searching: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const ServerSlice = createSlice({
	name: 'server',
	initialState,
	reducers: {

		clearServerItem: (state, action): ServerState => {
			return { ...state, server: null };
		},

		clearServerSearchResult: (state, action): ServerState => {
			return { ...state, search: [] };
		},

		onLoadCreate: (state, action ): ServerState => {
			return {...state, creating: true};
		},

		onLoadDelete: (state, action ): ServerState => {
			return {...state, deleting: true};
		},

		onLoadUpdate: (state, action ): ServerState => {
			return {...state, updating: true};
		},

		onLoadList: (state, action ): ServerState => {
			return {...state, gettingList: true};
		},

		onLoadItem: (state, action ): ServerState => {
			return {...state, gettingItem: true};
		},

		onLoadSearch: (state, action ): ServerState => {
			return {...state, search: [], searching: true};
		},

		// Success
		onSuccessCreate: (state, action): ServerState => {
			return {...state, creating: false};
		},

		onSuccessDelete: (state, action): ServerState => {
			return {...state, deleting: false};
		},

		onSuccessUpdate: (state, action): ServerState => {
			return {...state, updating: false};
		},

		onSuccessList: (state, action): ServerState => {
			return {...state, servers: action.payload.data, gettingList: false};
		},

		onSuccessItem: (state, action): ServerState => {
			return {...state, server: action.payload.data, gettingItem: false};
		},

		onSuccessSearch: (state, action): ServerState => {
			return {...state, search: action.payload.data, searching: false};
		},

		// Errors
		onFailCreate: (state, action): ServerState => {
			return {...state, creating: false };
		},
		onFailDelete: (state, action): ServerState => {
			return {...state, deleting: false };
		},
		onFailUpdate: (state, action): ServerState => {
			return {...state, updating: false };
		},
		onFailList: (state, action): ServerState => {
			return {...state, servers: [] };
		},
		onFailItem: (state, action): ServerState => {
			return {...state, server: null };
		},
		onFailSearch: (state, action): ServerState => {
			return { ...state, search: [], searching: false };
		},
	},
});

export const {
	clearServerItem,
	clearServerSearchResult
} = ServerSlice.actions;
